import api from '@/modules/api.service';
import type { ReadRelatorioAtividadeHistoricoDto } from '@/api.types';

export async function buscarRelatorioHistoricoUseCase(
  relatorioId: number,
): Promise<ReadRelatorioAtividadeHistoricoDto[]> {
  const response = await api.get<ReadRelatorioAtividadeHistoricoDto[]>(
    `/relatorios/atividades/${relatorioId}/historico`,
  );
  return Array.isArray(response.data) ? response.data : [];
}
